import { PageHeader } from 'antd';
import { useHistory } from 'react-router';
import { T } from 'react-translator-component';

import * as S from './styled';

import VoucherSelectUsersList from '../../organisms/VoucherSelectUsersList/VoucherSelectUsersList';

const VoucherSelectUsersPage = () => {
  const history = useHistory();

  return (
    <>
      <S.Wrapper>
        <PageHeader onBack={history.goBack} title={T('Select users for the voucher')} />

        <S.Blank>
          <VoucherSelectUsersList />
        </S.Blank>
      </S.Wrapper>
    </>
  );
};

export default VoucherSelectUsersPage;
